/* eslint-disable @typescript-eslint/naming-convention */
import { GasDeviceCategory, Nullable } from '@enmon/commons';
import { MeterDetailGas } from '@enmon/commons/lib/enmon';
import { Form } from 'antd';
import { FormItemProps } from 'components/Form/FormItem';
import { GasMeterDetailField } from 'components/Form/meter_details/gas/constants';
import { GasDetails } from 'components/Form/meter_details/gas/GasDetails';
import { VFC } from 'react';

export type MeterGasDetails = MeterDetailGas;

export interface MeterGasDetailsProps extends MeterGasDetails {
  onFormItemReset: (name: FormItemProps['name']) => void;
}

export const GasMeterDetails: VFC<MeterGasDetailsProps> = props => {
  const {
    deviceCategory,
    gSize,
    diameterNominal,
    layLength,
    measurementCategory,
    pMax,
    qMin,
    qMax,
    orientation,
    onFormItemReset,
  } = props;
  const form = Form.useFormInstance();

  const selectedDeviceCategory =
    Form.useWatch<Nullable<GasDeviceCategory>>(['detail', 'deviceCategory'], form) ?? deviceCategory;

  return (
    <GasDetails
      itemsConfig={{
        [GasMeterDetailField.DeviceCategory]: {
          formItemProps: {
            getValueFromEvent: (value?: string) => value ?? null,
            initialValue: selectedDeviceCategory,
            isSemiRequired: true,
            onResetField: onFormItemReset,
          },
        },
        [GasMeterDetailField.MeasurementCategory]: {
          formItemProps: {
            initialValue: measurementCategory,
            isSemiRequired: true,
            onResetField: onFormItemReset,
          },
        },
        [GasMeterDetailField.Orientation]: {
          formItemProps: { initialValue: orientation, isSemiRequired: true, onResetField: onFormItemReset },
        },
        [GasMeterDetailField.GSize]: {
          formItemProps: {
            initialValue: gSize,
            isSemiRequired: true,
            onResetField: onFormItemReset,
          },
        },
        [GasMeterDetailField.DiameterNominal]: {
          formItemProps: { initialValue: diameterNominal, isSemiRequired: true, onResetField: onFormItemReset },
        },
        [GasMeterDetailField.LayLength]: {
          formItemProps: { initialValue: layLength, isSemiRequired: true, onResetField: onFormItemReset },
          additionalConfig: { deviceCategory: selectedDeviceCategory },
        },
        [GasMeterDetailField.PMax]: {
          formItemProps: {
            initialValue: pMax,
            isSemiRequired: true,
            onResetField: onFormItemReset,
          },
        },
        [GasMeterDetailField.QMin]: {
          formItemProps: {
            initialValue: qMin,
            isSemiRequired: true,
            onResetField: onFormItemReset,
          },
        },
        [GasMeterDetailField.QMax]: {
          formItemProps: {
            initialValue: qMax,
            isSemiRequired: true,
            onResetField: onFormItemReset,
          },
        },
      }}
    />
  );
};
